// @ts-nocheck

import { find, filter, reduce, some, map, remove } from 'lodash';

import { BonusQueues, BonusStatuses } from '../constants/bonus';
import { StorageKeys } from '../constants/storage';
import { VipRank } from '../constants/vip';
import { LocalStorageAnimationsKeys } from '../modules/animations/constants/storage';
import { AnimationsActionTypes } from '../modules/animations/types/actions/animations';
import { LocalStorageLineUpKeys } from '../modules/line-up/constants/storage';
import { LineUpActionTypes } from '../modules/line-up/types/actions/lineUp';
import { LocalStorageMissionsKeys } from '../modules/missions/constants/storage';
import { AuthActionTypes } from '../types/actions/auth';
import { UserActionTypes } from '../types/actions/user';
import { BalanceChangeTypes } from '../types/balanceChanges';
import { storage } from '../utils';
import RoutesRedirectionFactory from '../utils/routes/RoutesRedirectionFactory';

const prefWinaTv = storage.localStorage.load('application:prefs:show-wtv');
const prefGrids = storage.localStorage.load('application:prefs:grids');
const localOddsTravelEnabled = storage.localStorage.load(LocalStorageAnimationsKeys.SHOULD_ANIMATE_ODDS_TRAVEL);
const localShowLineUpNotificationsInfosPopUp = storage.localStorage.load(
  LocalStorageLineUpKeys.SHOW_LINE_UP_NOTIFICATIONS_INFOS_POPUP,
);
const localDisplayBetSliders = storage.localStorage.load(StorageKeys.USER_OPTIONS_DISPLAY_BET_SLIDERS_BY_DEFAULT);

const DefaultPresets = [
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 1.1 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 1.25 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 1.5 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 1.75 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 2.25 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 3 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 5 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 10 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 25 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 50 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 100 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 500 },
  { presets: [200, 500, 1000, 2000, -1], maxOdds: 5000 },
  { presets: [200, 500, 1000, 2000, -1] },
];

const vipRank = {
  chrome: 1,
  aluminium: 2,
  bronze: 3,
  silver: 4,
  gold: 5,
  platinum: 6,
  'diamond *': 7,
  'diamond **': 8,
  'diamond ***': 9,
  'diamond ****': 10,
  'diamond *****': 11,
  'red diamond': 12,
};

const RED_DIAMOND_MILES = 2500000;
const PERCENTAGE = 100;

export const userDefaultState = {
  //user related
  connected: false,
  connecting: false,
  jwt: null,
  didReceivedUserData: false,
  newuser: false,
  nickname: '',
  balance: 0,
  balanceCash: 0,
  balanceBonus: 0,
  freebetBankroll: 0,
  balanceDiff: null,

  bankrollVariation: {
    balance: {
      lastChangeTs: null,
      lastChangeOrigin: null,
      lastChangeType: null,
      shouldAnimateBankroll: false,
    },
    freebets: {
      lastChangeTs: null,
      lastChangeOrigin: null,
      lastChangeType: null,
      shouldAnimateBankroll: false,
    },
  },
  presets: DefaultPresets,
  lastSessionSettledBets: [],
  embeddedNotificationTarget: '',

  mustValidateCGU: false,
  mustValidateEvents: false,
  messages: null,

  miles: {
    currentMiles: 0,
    availableMiles: 0,
    name: '',
    nextRankName: '',
    nextStepMiles: 0,
    percentageDistribution: 0,
    keepCurrentLevel: null,
  },

  bonuses: [],
  tickets: {
    play: [],
    real: [],
  },
  //user's device related
  prefs: {
    showWTV: true,
    calendar: {
      filters: {
        sportIds: {},
      },
      hour: 24,
    },
    live: {
      filters: {
        sportIds: {},
      },
    },
    favorites: {
      filters: {
        sportIds: {},
      },
    },
  },
  cc: null,
  sessionId: null,
  promotionStatus: 0,
  missionsModerator: false,
  oddsTravelEnabled: true,
  showLineUpNotificationsInfosPopUp: true,
  displayBetSliders: true, // On active l'affichage slider par defaut
};

const initialState = {
  ...userDefaultState,
  connected: window.getOuid?.() > 0,
  prefs: {
    ...userDefaultState.prefs,
    showWTV: prefWinaTv !== null ? prefWinaTv : true,
    grids: prefGrids !== null ? prefGrids : userDefaultState.prefs.grids,
  },
  oddsTravelEnabled:
    typeof localOddsTravelEnabled === 'boolean' ? localOddsTravelEnabled : userDefaultState.oddsTravelEnabled,
  showLineUpNotificationsInfosPopUp:
    typeof localShowLineUpNotificationsInfosPopUp === 'boolean'
      ? localShowLineUpNotificationsInfosPopUp
      : userDefaultState.showLineUpNotificationsInfosPopUp,
  displayBetSliders:
    typeof localDisplayBetSliders === 'boolean' ? localDisplayBetSliders : userDefaultState.displayBetSliders,
};

export default (history) =>
  (state = initialState, action) => {
    const { location } = history ?? {};
    const { pathname, hash } = location ?? {};

    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (action.type) {
      case UserActionTypes.SET_CC: {
        return {
          ...state,
          cc: action.payload.cc,
        };
      }
      case UserActionTypes.SET_SESSIONID: {
        return {
          ...state,
          sessionId: action.payload.sessionId,
        };
      }
      case UserActionTypes.SET_MUST_VALIDATE_CGU: {
        return {
          ...state,
          mustValidateCGU: action.payload.value,
        };
      }
      case UserActionTypes.SET_MUST_VALIDATE_EVENTS: {
        return {
          ...state,
          mustValidateEvents: action.payload.value,
        };
      }
      case UserActionTypes.ACK_MESSAGE: {
        return {
          ...state,
          messages: Array.isArray(state.messages) ? state.messages.slice(1) : state.messages,
        };
      }
      case UserActionTypes.SET_CONNECTED: {
        if (
          (pathname && pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1) ||
          (hash && hash.indexOf('mission') !== -1)
        ) {
          const currentLocalCachedUser = JSON.parse(localStorage.getItem(LocalStorageMissionsKeys.USER) ?? '{}');
          const nextLocalCachedUser = { ...currentLocalCachedUser, connected: true };
          localStorage.setItem(LocalStorageMissionsKeys.USER, JSON.stringify(nextLocalCachedUser));
        }
        return {
          ...state,
          connected: true,
        };
      }
      case UserActionTypes.SET_LAST_SESSION_SETTLED_BETS: {
        const { lastSessionSettledBets } = action.payload;
        return {
          ...state,
          lastSessionSettledBets,
        };
      }
      case UserActionTypes.SET_PRESETS: {
        const { presets } = action.payload;
        return {
          ...state,
          presets,
        };
      }
      case UserActionTypes.CLEAR_LAST_SESSION_SETTLED_BETS: {
        return {
          ...state,
          lastSessionSettledBets: initialState.lastSessionSettledBets,
        };
      }
      case UserActionTypes.SET_EMBEDDED_NOTIFICATION_TARGET: {
        const { embeddedNotificationTarget } = action.payload;
        return {
          ...state,
          embeddedNotificationTarget,
        };
      }
      case UserActionTypes.SET_MESSAGES: {
        const { messages } = action.payload;
        return {
          ...state,
          messages,
        };
      }

      case UserActionTypes.SET_DISCONNECTED: {
        if (
          (pathname && pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1) ||
          (hash && hash.indexOf('mission') !== -1)
        ) {
          const currentLocalCachedUser = JSON.parse(localStorage.getItem(LocalStorageMissionsKeys.USER) ?? '{}');
          const nextLocalCachedUser = { ...currentLocalCachedUser, connected: false };
          localStorage.setItem(LocalStorageMissionsKeys.USER, JSON.stringify(nextLocalCachedUser));
        }
        return {
          ...state,
          jwt: null,
          cc: null,
          sessionId: null,
          connected: false,
          newuser: false,
          nickname: '',
          balance: 0,
          balanceCash: 0,
          balanceBonus: 0,
          freebetBankroll: 0,
          realMoney: true,
          mustValidateCGU: false,
          mustValidateEvents: false,
          lastSessionSettledBets: [],
          embeddedNotificationTarget: '',
          didReceivedUserData: false,
          // On ne reset pas messages car on peut avoir des messages qui ont été positionné avant la déconnexion
          // messages: null,
          miles: {
            currentMiles: 0,
            availableMiles: 0,
            name: '',
            nextRankName: '',
            nextStepMiles: 0,
            percentageDistribution: 0,
            keepCurrentLevel: null,
          },
          bonuses: [],
        };
      }
      case UserActionTypes.SET_FLAG_NEWUSER: {
        return {
          ...state,
          newuser: true,
        };
      }
      case UserActionTypes.SET_REALMONEY: {
        const { realMoney } = action.payload;
        return {
          ...state,
          realMoney,
        };
      }
      case UserActionTypes.SET_BANKROLL: {
        const { balance, balanceCash, balanceBonus, freebetBankroll, origin = null, type = null } = action.payload;

        let balanceHasChanged = false;
        let balanceCashHasChanged = false;
        let balanceBonusHasChanged = false;
        let freebetBankrollHasChanged = false;

        if (balance !== null && balance !== undefined) {
          if (balance !== state.balance) {
            balanceHasChanged = true;
          }
        }

        if (balanceCash !== null && balanceCash !== undefined) {
          if (balanceCash !== state.balanceCash) {
            balanceCashHasChanged = true;
          }
        }

        if (balanceBonus !== null && balanceBonus !== undefined) {
          if (balanceBonus !== state.balanceBonus) {
            balanceBonusHasChanged = true;
          }
        }

        if (freebetBankroll !== null && freebetBankroll !== undefined) {
          if (freebetBankroll !== state.freebetBankroll) {
            freebetBankrollHasChanged = true;
          }
        }

        if (balanceHasChanged || balanceCashHasChanged || balanceBonusHasChanged || freebetBankrollHasChanged) {
          const now = Date.now();

          return {
            ...state,
            balance: balanceHasChanged ? balance : state.balance,
            balanceCash: balanceCashHasChanged ? balanceCash : state.balanceCash,
            balanceBonus: balanceBonusHasChanged ? balanceBonus : state.balanceBonus,
            freebetBankroll: freebetBankrollHasChanged ? freebetBankroll : state.freebetBankroll,
            bankrollVariation:
              balanceHasChanged || freebetBankrollHasChanged
                ? {
                    ...state.bankrollVariation,
                    balance: balanceHasChanged
                      ? {
                          ...state.bankrollVariation.balance,
                          lastChangeTs: now,
                          lastChangeOrigin: origin,
                          lastChangeType: type,
                          shouldAnimateBankroll: type === BalanceChangeTypes.CREDIT,
                        }
                      : state.bankrollVariation.balance,
                    freebets: freebetBankrollHasChanged
                      ? {
                          ...state.bankrollVariation.freebets,
                          lastChangeTs: now,
                          lastChangeOrigin: origin,
                          lastChangeType: type,
                          shouldAnimateBankroll: type === BalanceChangeTypes.CREDIT,
                        }
                      : state.bankrollVariation.freebets,
                  }
                : state.bankrollVariation,
          };
        }

        return state;
      }
      case UserActionTypes.SET_PREFERENCES: {
        const { id, prefs } = action.payload;
        return {
          ...state,
          prefs: {
            ...state.prefs,
            [id]: prefs,
          },
        };
      }
      case UserActionTypes.CLEAR_PREFERENCES: {
        const { id } = action.payload;
        return {
          ...state,
          prefs: {
            ...state.prefs,
            [id]: {
              ...state.prefs[id],
              filters: {
                sportIds: {},
              },
            },
          },
        };
      }
      case UserActionTypes.SET_CALENDAR_HOUR_PREFERENCE: {
        const { hour } = action.payload;
        return {
          ...state,
          prefs: {
            ...state.prefs,
            calendar: {
              ...state.prefs.calendar,
              hour,
            },
          },
        };
      }
      case UserActionTypes.SET_NICKNAME: {
        const { nickname } = action.payload;

        if (
          (pathname && pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1) ||
          (hash && hash.indexOf('mission') !== -1)
        ) {
          const currentLocalCachedUser = JSON.parse(localStorage.getItem(LocalStorageMissionsKeys.USER) ?? '{}');
          const nicknameJustChanged = !!state.nickname && nickname !== state.nickname;
          const nextLocalCachedUser = { ...currentLocalCachedUser, nicknameJustChanged };

          localStorage.setItem(LocalStorageMissionsKeys.USER, JSON.stringify(nextLocalCachedUser));
        }

        return {
          ...state,
          nickname,
        };
      }
      case UserActionTypes.SET_CONNECTING: {
        const { connecting } = action.payload;
        return {
          ...state,
          connecting,
        };
      }
      case UserActionTypes.SET_AFFILIATION: {
        const { godfatherAmount, godsonAmount } = action.payload;
        return {
          ...state,
          godfatherAmount,
          godsonAmount,
        };
      }
      case UserActionTypes.SET_MILES: {
        const {
          thisMonthTotalMiles,
          thisYearTotalMiles,
          availableMiles,
          name,
          milesToKeepLevel,
          milesToNextLevel,
          nextRankName,
        } = action.payload;

        let nextLevelMiles = milesToNextLevel;
        const isYearlyRank = name.length && vipRank[name] >= vipRank['platinum'];

        if (nextLevelMiles) {
          if (isYearlyRank) {
            nextLevelMiles = milesToNextLevel + thisYearTotalMiles;
          } else {
            nextLevelMiles = milesToNextLevel + thisMonthTotalMiles;
          }
        }

        const currentMiles = isYearlyRank ? thisYearTotalMiles : thisMonthTotalMiles;
        const nextStepMiles =
          (milesToKeepLevel ? milesToKeepLevel + thisMonthTotalMiles : nextLevelMiles) || RED_DIAMOND_MILES;
        const percentageDistribution = nextStepMiles
          ? nextStepMiles > currentMiles
            ? (currentMiles * PERCENTAGE) / nextStepMiles
            : PERCENTAGE
          : nextStepMiles;
        const keepCurrentLevel = name === VipRank.RED_DIAMOND || !!milesToKeepLevel;

        const styledName = name.length ? name[0].toUpperCase() + name.slice(1) : name;
        const styledNextName = nextRankName.length
          ? nextRankName[0].toUpperCase() + nextRankName.slice(1)
          : nextRankName;

        return {
          ...state,
          miles: {
            currentMiles,
            nextStepMiles,
            availableMiles,
            name: styledName,
            nextRankName: styledNextName,
            keepCurrentLevel,
            percentageDistribution,
          },
        };
      }

      case UserActionTypes.SET_TICKETS: {
        const { play, real } = action.payload;

        return {
          ...state,
          tickets: {
            play,
            real,
          },
        };
      }

      case UserActionTypes.SET_BONUSES: {
        const { bonuses, bonusCodes } = action.payload;
        const bonusesList = [];
        const bonusesQueue = [
          {
            bonusSortByStatus: filter(bonuses, (bonus) => bonus.status === BonusStatuses.RUNNING),
            bonusQueue: [filter(bonusCodes, (code) => code)],
          },
          {
            bonusSortByStatus: filter(bonuses, (bonus) => bonus.status === BonusStatuses.PENDING),
            bonusQueue: [
              filter(bonusCodes, (code) => code.bonusQueue === BonusQueues.PRIMARY),
              filter(bonusCodes, (code) => code.bonusQueue === BonusQueues.BETTING),
              filter(bonusCodes, (code) => code.bonusQueue === BonusQueues.POKER),
              filter(bonusCodes, (code) => code.bonusQueue === BonusQueues.VIP),
            ],
          },
        ];

        some(bonusesQueue, (bonuses) => {
          const { bonusQueue, bonusSortByStatus } = bonuses;

          some(bonusQueue, (codes) => {
            if (codes.length) {
              const bonusIds = map(codes, (code) => code.bonusCodeId);
              const filteredBonus = filter(bonusSortByStatus, (bonus) => bonusIds.includes(bonus.bonusCodeId));

              while (filteredBonus.length) {
                const nextBonus = reduce(
                  filteredBonus,
                  (prev, curr) => {
                    return prev === null || new Date(prev?.enqueueDate) > new Date(curr?.enqueueDate) ? curr : prev;
                  },
                  null,
                );

                const bonusType = find(codes, (code) => code.bonusCodeId === nextBonus.bonusCodeId)?.bonusType;
                const percentageDistribution =
                  nextBonus.requiredMiles &&
                  (nextBonus.requiredMiles > nextBonus.acquiredMiles
                    ? (nextBonus.acquiredMiles * PERCENTAGE) / nextBonus.requiredMiles
                    : PERCENTAGE);

                bonusesList.push({
                  title: nextBonus.explanation,
                  amount: nextBonus.amount,
                  status: nextBonus.status,
                  bonusType,
                  percentageDistribution,
                });

                remove(filteredBonus, nextBonus);

                if (bonusesList.length === 2) {
                  break;
                }
              }
            }
            return bonusesList.length === 2;
          });
          return bonusesList.length === 2;
        });

        return {
          ...state,
          bonuses: bonusesList,
        };
      }

      case AuthActionTypes.RECEIVED_TOKEN: {
        const { jwt, expirationDelay } = action.payload;
        return { ...state, jwt: { token: jwt, expirationDelay } };
      }

      case AuthActionTypes.INVALIDATE_TOKEN: {
        return { ...state, jwt: null };
      }

      case UserActionTypes.SET_DID_RECEIVED_DATA: {
        const { didReceivedUserData } = action.payload;
        return { ...state, didReceivedUserData };
      }

      case UserActionTypes.SET_MISSIONS_MODERATOR: {
        const { missionsModerator } = action.payload;
        const nextState = { ...state, missionsModerator };

        if (
          pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1 ||
          hash.indexOf('mission') !== -1
        ) {
          const currentLocalCachedUser = JSON.parse(localStorage.getItem(LocalStorageMissionsKeys.USER) ?? '{}');
          const nextLocalCachedUser = { ...currentLocalCachedUser, missionsModerator };
          localStorage.setItem(LocalStorageMissionsKeys.USER, JSON.stringify(nextLocalCachedUser));
        }

        return nextState;
      }

      case UserActionTypes.SET_PROMOTION_STATUS: {
        const { promotionStatus } = action.payload;
        const nextState = { ...state, promotionStatus };

        if (
          pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1 ||
          hash.indexOf('mission') !== -1
        ) {
          const currentLocalCachedUser = JSON.parse(localStorage.getItem(LocalStorageMissionsKeys.USER) ?? '{}');
          const nextLocalCachedUser = { ...currentLocalCachedUser, promotionStatus };
          localStorage.setItem(LocalStorageMissionsKeys.USER, JSON.stringify(nextLocalCachedUser));
        }

        return nextState;
      }

      case UserActionTypes.TOGGLE_OPTION_DISPLAY_SLIDERS: {
        const displayBetSliders = !state.displayBetSliders;
        const nextState = {
          ...state,
          displayBetSliders,
        };

        localStorage.setItem(StorageKeys.USER_OPTIONS_DISPLAY_BET_SLIDERS_BY_DEFAULT, displayBetSliders);

        return nextState;
      }

      case AnimationsActionTypes.TOGGLE_ODDS_TRAVEL_OPTION: {
        const oddsTravelEnabled = !state.oddsTravelEnabled;
        const nextState = {
          ...state,
          oddsTravelEnabled,
        };

        localStorage.setItem(LocalStorageAnimationsKeys.SHOULD_ANIMATE_ODDS_TRAVEL, oddsTravelEnabled);

        return nextState;
      }

      case LineUpActionTypes.CLOSE_NOTIFICATIONS_INFOS_POP_UP: {
        const localShowLineUpNotificationsInfosPopUp = false;
        const nextState = {
          ...state,
          showLineUpNotificationsInfosPopUp: localShowLineUpNotificationsInfosPopUp,
        };

        localStorage.setItem(
          LocalStorageLineUpKeys.SHOW_LINE_UP_NOTIFICATIONS_INFOS_POPUP,
          localShowLineUpNotificationsInfosPopUp,
        );

        return nextState;
      }

      default:
        return state;
    }
  };
